/**
 * Commission on what Wally collects from registered offices (convention art. 3; docs/PLAN.md §7, §8).
 * Money is integer cents (EUR) excl. VAT; rates are fractions.
 */
import { z } from 'zod';
import { isoDay } from './common.js';
/** Staff corrections on a line (plan §7: paid date; art. 5.3: tail). */
export const updateCommissionLineSchema = z
    .object({
    paidOnOverride: isoDay.nullable().optional(),
    tail: z.boolean().optional(),
})
    .strict();
/** Staff record the seats a billing group assigned to the office, from a day on (plan §13). */
export const seatSnapshotInputSchema = z
    .object({
    from: isoDay,
    seats: z.number().int().min(0).max(100_000),
    groupSeats: z.number().int().min(0).max(100_000).nullable(),
})
    .strict();
